import { render, staticRenderFns } from "./Clusters.vue?vue&type=template&id=0ec77c58"
import script from "./Clusters.vue?vue&type=script&lang=js"
export * from "./Clusters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports